<div class="auto-config-wrapper">
  <h1 class="title">{{ 'sources.AutoConfig.Title' | translate }}</h1>
  <p class="description">{{ 'sources.AutoConfig.Description' | translate }}</p>

  <div class="layers-wrapper">
    <div class="header">
      <h6 class="source-layers-header">{{ 'sources.AutoConfig.TakenFrom' | translate }}</h6>
      <h6 class="destination-layers-header">{{ 'sources.AutoConfig.AppliedTo' | translate }}</h6>
    </div>

    <div class="changed-layers">
      <div class="row" *ngFor="let layer of copyConfigConfirmationData.ModelChanges">
        <mee-auto-config-layer [layer]="layer.SourceLayer" [displayWithSourceName]="true"></mee-auto-config-layer>
        <mat-icon class="applied-to-arrow">arrow_forward_ios</mat-icon>
        <mee-auto-config-layer [layer]="layer.DestinationLayer"></mee-auto-config-layer>
      </div>

      <div class="row" *ngFor="let layer of copyConfigConfirmationData.LayerChanges">
        <mee-auto-config-layer [layer]="layer.SourceLayer" [displayWithSourceName]="true"></mee-auto-config-layer>
        <mat-icon class="applied-to-arrow">arrow_forward_ios</mat-icon>
        <mee-auto-config-layer [layer]="layer.DestinationLayer"></mee-auto-config-layer>
      </div>
    </div>
  </div>

  <div class="controls">
    <button class="cancel-button" mat-button [mat-dialog-close]="false">{{ "system.discard" | translate | uppercase }}</button>
    <button class="copy-button" mat-raised-button [mat-dialog-close]="true">
      {{ "system.apply" | translate | uppercase }}
    </button>
  </div>
</div>
